/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q5Inputs */

const et_faq_q5 = /** @type {(inputs: Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuidas saada rohkem ostuvalmis kliente ilma Google'i või Meta reklaamidele raha põletamata?`)
};

const en_faq_q5 = /** @type {(inputs: Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can I get more purchase-ready clients without burning money on Google or Meta ads?`)
};

/**
* | output |
* | --- |
* | "How can I get more purchase-ready clients without burning money on Google or Meta ads?" |
*
* @param {Faq_Q5Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q5 = /** @type {((inputs?: Faq_Q5Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q5Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q5(inputs)
	return en_faq_q5(inputs)
});